

import React, {useEffect, useRef, useState} from "react";
import { message, Col, Row, Button, Collapse , Modal, Tooltip} from 'antd';
import courseTeacherMenuStyles from "./course-main-teacher-menu.module.less";
import "../course.module.css";
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../../constants/constants'
import courseMainStyles from "../course-main.module.less";

import {checkUserLogin} from "../../common/user-center/user-info";
import { FilePdfOutlined ,BarsOutlined,VideoCameraOutlined,CodeOutlined,LockOutlined, ExperimentOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";
import { sendHttpPostRequest } from "../../../api/http-request";

import Icon from '@ant-design/icons'
import  {ReactComponent as myplaySvg }   from '../../../static/image/course/myplay.svg'
const myplayIcon = (props:any) => (<Icon component={myplaySvg} {...props} />)

import  {ReactComponent as myexerciseSvg }   from '../../../static/image/course/myexerciseorange.svg'
const myexerciseIcon = (props:any) => (<Icon component={myexerciseSvg} {...props} />)

import  {ReactComponent as myvideoSvg }   from '../../../static/image/course/myvideo.svg'
const myvideoIcon = (props:any) => (<Icon component={myvideoSvg} {...props} />)

import  {ReactComponent as mypdfSvg }   from '../../../static/image/course/mypdf.svg'
const mypdfIcon = (props:any) => (<Icon component={mypdfSvg} {...props} />)


import Draggable from "react-draggable";

export interface Props {
    menu_id:any,
    course_id: number,
    ispay:any,
    is_teacher: any,
    is_in_college: any
    is_outdate:any
}

/** 平台课程大纲标签页 */
export const PlatformMenuPreview: React.FC<Props> = (props) => {
    const {menu_id} = props;
    const {course_id} = props;
    const {ispay} = props;
    const {is_teacher} = props;
    const {is_in_college} = props;
    const {is_outdate} =props;
    
   // console.log(is_in_college);
   // console.log(is_teacher);

    const [menu,setMenu] = useState(null as any);
    const [manager,setManager] = useState(null as any);
   
    const [isBuyModalVisible, setIsBuyModalVisible] = useState(false);
    const draggleRef = useRef<HTMLDivElement | null>(null);
    const [bounds,setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [disabled,setDisabled] = useState(true)
  
    const onStart = (event:any, uiData:any) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement;
      const targetRect= draggleRef?.current?.getBoundingClientRect();
      if(targetRect){
        setBounds( {
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        }
      )
      }
    }


    /**
     * 查询大纲
     */

    useEffect(() => {
        queryMenu();  
        queryCollegeManager();
    }, [])

     const queryMenu = () => {
        sendHttpPostRequest(
            'course/api/user_query_menu_by_id',
            {
                sessionid: Cookies.get("sessionid"),
                menu_id: menu_id,
                format : 1
            },
            queryMenuCallback
        )
    }
  
    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuCallback = (response: any) => {
        if (response.code == -100) {
            // 未登录
            document.getElementById("show-login-modal")!.click();
        } else if (response.is_ok == true) {
            // 成功
            setMenu(response.query_info);
            
        } else {
            message.error(response.message);
        }
    }

    const queryCollegeManager = () => {
        sendHttpPostRequest(
            'college/api/user_query_college_manager_info',
            {
                sessionid: Cookies.get("sessionid"),
            },
            queryManagerInfoCallback
        )
    }
  
    /**
     * 查询机构管理员回调
     * @param response
     */
    const queryManagerInfoCallback = (response: any) => {
        if (response.code == -100) {
            // 未登录
            document.getElementById("show-login-modal")!.click();
        } else if (response.is_ok == true) {
            // 成功
            setManager(response.manager_info);
        } else {
            //message.error(response.message);
        }
    }

    const onKnowledgeClick = (chapter_id: number, knowledge_id: number,chapterInd:number, knowledgeInd:number) => {
        console.log(chapterInd);
        console.log(knowledgeInd);
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            console.log(ispay);
            if(ispay == false){
                if(chapterInd == 0 && knowledgeInd == 0){
                    window.open(`/module-learn-preview?module_id=${knowledge_id}`);
                }else{
                    setIsBuyModalVisible(true);
                }
            }else  if(is_outdate == true){
                if(chapterInd == 0 && knowledgeInd == 0){
                    window.open(`/module-learn-preview?module_id=${knowledge_id}`);
                }else{
                    setIsBuyModalVisible(true);
                }
            } else {
                window.open(`/course-learn?course/${course_id}/chapter/${chapter_id}/knowledge/${knowledge_id}/`);
            }    
        }
    }

    return (
        <div >

            {
            menu?.json?.map((chapter, chapterInd)=>(
               <div className={courseTeacherMenuStyles.chapterWrapper} key={chapterInd}> 
                    <div className={courseTeacherMenuStyles.chapterName} style={{width:"100%",textAlign:'left',fontWeight: 700}} > { "第" +  (chapterInd + 1)  + "章 " + chapter.name}</div>
                    <div className={courseTeacherMenuStyles.modulesWrapper} >
                        {chapter?.tasks?.map((module, moduleIndex) => (
                            <div key={module.id} style={{cursor:"pointer",width:"100%"}} className={courseTeacherMenuStyles.modules} onClick={onKnowledgeClick.bind(this, chapter.id, module.id,chapterInd, moduleIndex)}>
                                <Row  wrap={false}  align="middle" >
                                    <Col style={{textAlign: 'left' }} flex="auto">
                                        <div>
                                        <div className={courseTeacherMenuStyles.moduleName}>{chapterInd + 1 + '.' + (moduleIndex + 1) + ' ' + module.name}</div>
                                        <div className={courseTeacherMenuStyles.moduleDesp}>
                                            {module?.type == 1 ? (
                                                <span >
                                                <Icon component={mypdfIcon}/>
                                                    PDF · {module?.lecture_pages}页
                                                </span>
                                                
                                            ) : (
                                            <span >
                                                <Icon component={myvideoIcon}/>
                                                视频 · {module?.video_duration_str}
                                                </span>
                                                
                                            )}


                                    {module.if_case && (
                                        <span style={{marginLeft:16}}>
                                            
                                            <ExperimentOutlined style={{color:'rgb(168 85 247)'}}/>

                                            含实验
                                        </span>
                                        )}

                                        {module.if_practice && (
                                        <span style={{marginLeft:16}}>
                                            
                                            <Icon component={myexerciseIcon}/>

                                            含练习
                                        </span>
                                        )}

                                        </div>
                                        </div>



                                    </Col>

                                    <Col flex="60px" style={{ textAlign: 'right' }}>

                                        <div> 
                                            
                                            { (ispay == false  &&  !(chapterInd == 0 && moduleIndex == 0) ) ?

                                                <LockOutlined className={courseTeacherMenuStyles.iconbuttons}/>:  
                                             (ispay == true  && is_outdate == true && !(chapterInd == 0 && moduleIndex == 0) )?
                                                
                                                <LockOutlined className={courseTeacherMenuStyles.iconbuttons}/> : <span title='学习' className={courseTeacherMenuStyles.playIconWrapper}><Icon component={ myplayIcon}/></span>                     
                                                                
                                            }
                                            
                                            
                                        </div>
                                    
                                    </Col>

                                </Row>  
                            </div>
                        ))}
                    </div>
                </div> 
            ))                 
         }

                <Modal 
                    title={<div style={{ width: '100%',cursor: 'move',}}
                    onMouseOver={() => {if (disabled) {setDisabled(false)}}}
                    onMouseOut={() => {setDisabled(true)}}
                    onFocus={() => {}}
                    onBlur={() => {}}
                    >
                        提示</div>
                    }
                    width={400}
                    closable={false}
                    open={isBuyModalVisible}
                    className={courseMainStyles.miniModal}
                    footer={              
                        <div>
                        {is_in_college == true &&
                            <Button className={courseMainStyles.stepsBtn}
                            style={{marginRight:20,color:'#fff', textShadow:'none', boxShadow:'none'}}
                            type="primary"
                            onClick={()=>{setIsBuyModalVisible(false)}}>确认</Button>
                        }
                        {is_in_college == false &&
                        <div>
                            <Button className={courseMainStyles.stepsBtn}
                            style={{marginRight:20,color:'#07c160'}}
                            onClick={()=>{setIsBuyModalVisible(false)}}>取消</Button>
                            <Button className={courseMainStyles.stepsBtn}
                            style={{marginRight:20,color:'#fff'}}
                            type="primary"
                            onClick={()=>{window.open("/user-center")}}>填写</Button></div>
                        }
                        </div>                    
                    }
                    modalRender={modal => (<div>
                        <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                        >
                        <div ref={draggleRef}>{modal}</div>
                        </Draggable> </div>
                    )}
                    >
                        {is_in_college == true && is_teacher == 1 && ispay == false &&
                       <div style={{width:350,textAlign:'center',paddingTop:20}}>
                       <p>您所在院校未购买该课程。</p> 
                       <p>若您是院校管理员，请联系 <span style={{color:'#07c160'}}>136 9329 0406</span></p>  
                       <p>若您是教师，请联系院校管理员 
                        <span style={{margin:'0 5px'}}><img
                                    className={GlobalCss.avatar}
                                    src={BACKEND_API_URL + manager?.avatar}
                                    alt=""
                                /> 
                            </span>
                        
                            {manager?.real_name == ''
                            ? manager?.nick_name
                            : manager?.real_name}

                         <span style={{color:'#07c160'}}>{manager?.phone}</span> </p>  
                          </div>}

                        {is_in_college == true && is_teacher == 1 && ispay == true && is_outdate == true &&
                         <div style={{width:350,textAlign:'center',paddingTop:20}}>
                         <p>该课程已过服务期</p> 
                         <p>若您是院校管理员，请联系 <span style={{color:'#07c160'}}>136 9329 0406</span></p>  
                         <p>若您是教师，请联系院校管理员 
                          <span style={{margin:'0 5px'}}><img
                                      className={GlobalCss.avatar}
                                      src={BACKEND_API_URL + manager?.avatar}
                                      alt=""
                                  /> 
                              </span>
                          
                              {manager?.real_name == ''
                              ? manager?.nick_name
                              : manager?.real_name}

                           <span style={{color:'#07c160'}}>{manager?.phone}</span> </p>  
                            </div>}

                        {is_in_college == true && is_teacher == 0 && ispay == false &&
                         <div style={{width:350,textAlign:'center',paddingTop:20}}>
                         <p>您所在院校未购买该课程，请联系院校管理员 </p>
                         <p><span style={{margin:'0 5px'}}><img
                                      className={GlobalCss.avatar}
                                      src={BACKEND_API_URL + manager?.avatar}
                                      alt=""
                                  /> 
                              </span>
                          
                              {manager?.real_name == ''
                              ? manager?.nick_name
                              : manager?.real_name}

                           <span style={{color:'#07c160'}}>{manager?.phone}</span> 
                        </p>  
                        </div>}

                        {is_in_college == true && is_teacher == 0 && ispay == true && is_outdate == true &&
                         <div style={{width:350,textAlign:'center',paddingTop:20}}>
                               <p>该课程已过服务期，请联系院校管理员</p> 
                                <p><span style={{margin:'0 5px'}}><img
                                            className={GlobalCss.avatar}
                                            src={BACKEND_API_URL + manager?.avatar}
                                            alt=""
                                        /> 
                                    </span>
                                
                                    {manager?.real_name == ''
                                    ? manager?.nick_name
                                    : manager?.real_name}

                                 <span style={{color:'#07c160'}}>{manager?.phone}</span> </p>  
                        </div>}

                        {is_in_college == false &&
                         <div style={{width:350,textAlign:'center',paddingTop:20}}>
                              你还没加入院校，请联系我们查询院校管理员联系方式或开通院校机构。
                              <p>联系方式：<span style={{color:'#07c160'}}>136 9329 0406</span> </p>
                        </div>}

            </Modal>

     
        </div>
    )

}

export default PlatformMenuPreview

